<template>
  <div class="detail" :id="activity618 ? 'activity618' : ''">
    <AppNavbar
      :options="options"
      :placeholder="true"
      :zIndex="999"
      :title="title"
    >
    </AppNavbar>
    <div class="" style="margin-top: 25px">
      <van-tabs v-model="curNav" line-height="0px" swipeable>
        <van-tab
          :title="item.title"
          v-for="(item, index) in navData"
          :key="index"
        >
          <template #title>
            <div class="nav-item">
              <div class="icon">
                <div class="new" v-if="item.isNew">NEW</div>
                <img class="image" :src="getNavIcon(item, index)" alt="" />
              </div>
              <div class="text">{{ item.title }}</div>
            </div>
          </template>
          <div class="content">
            <div v-if="item.id == 2">
              <img
                class="item-image image-2"
                :src="imageitem"
                alt=""
                v-for="(imageitem, imageindex) in item.list"
                :key="imageindex"
              />
              <div class="more-course">更多课程更新中...</div>
            </div>
            <div v-else>
              <img
                class="item-image image-1"
                :src="imageitem"
                alt=""
                v-for="(imageitem, imageindex) in item.list"
                :key="imageindex"
              />
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 底部 -->
    <div class="btm-buy-btn btm-buy-btn-fixed" v-if="curVipData">
      <div class="protocol" :class="{ 'check-wobble': wobble }"
        ><span
          class="check"
          :class="{ 'check-active': readProtocol }"
          @click="bindProtocol"
          ><span class="iconfont icon-gou" v-show="readProtocol"></span></span
        ><span>我已阅读并同意</span
        ><span class="text" @click="bindToAgreement">会员服务协议</span></div
      >
      <div class="buy-content">
        <div class="consult-btn" @click="bindConsult">
          <div class="iconfont icon-kefuicon"></div>
          <div class="text">咨询客服</div>
        </div>
        <div
          class="buy-btn"
          @click="bindBuyVip('bot')"
          v-buried
          :data-buried="BuriedData.BG_VIP_OPEN_TAB[curVipData.type_id]"
          v-clickBuried
          :data-click-buried="BuriedData.CLICK_VIP_OPEN_TAB[curVipData.type_id]"
        >
          <div class="b-buy-left">
            <span class="b-buy-unit">¥</span
            ><span class="b-buy-num">{{ curVipData.real_price }}</span
            ><span class="b-buy-time"
              >/{{ vipTypeOptions[curVipData.type_id] }}</span
            >
          </div>
          <div class="b-buy-text"> 开通会员 </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BuriedData } from './components/data'
import { mapState } from 'vuex'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import { vipRightImage, vipTypeOptions } from './components/data'
export default {
  components: {
    AppNavbar
  },
  data() {
    return {
      BuriedData,
      vipRightImage,
      vipTypeOptions,
      title: 'betterWE减脂会员',
      options: {
        barBackgroundColor: 'transparent',
        color: 'rgb(255,255,255)'
      },
      wobble: false,
      readProtocol: false,
      curNav: 0,
      navData: [],
      curVipData: null,
      recommendType: 2,
      activity618: false
    }
  },
  computed: {
    ...mapState('betterweVip', ['sellCard'])
  },
  created() {
    this.activity618 = +this.$route.query.activity618
    this.getData()
  },
  mounted() {
    console.log(this.$store)
    this.addScrollEvent()
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    //联系客服
    bindConsult() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          `/miniProgram?userName=gh_0d804ee2c21b&path=pages/image-page/index?url= https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fa5b3ae4ebbaa2707bcb11489bdb668c1.jpg&title=添加陪伴官`
        )
      }
    },
    getNavIcon(item, index) {
      return index == this.curNav ? item.activeIcon : item.icon
    },
    getData() {
      console.log(this.$route)
      this.curNav = +this.$route.query.index
      this.vipRightImage.map((item) => {
        if (item.id == this.$route.query.id) {
          this.navData = item.list[2].data
        }
      })
      if (this.sellCard && this.sellCard.length) {
        this.sellCard.map((item) => {
          if (item.type_id == this.$route.query.id) {
            this.curVipData = item
          }
        })
      }
    },
    bindProtocol() {
      this.readProtocol = !this.readProtocol
    },
    bindToAgreement() {
      this.$router.push('/betterwe/vip-agreement')
    },
    bindClickNav(index) {
      this.curNav = index
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset

      if (scrollTop >= 100) {
        this.options = {
          barBackgroundColor: 'rgba(19, 17, 23, 1)',
          color: '#fff'
        }
      } else {
        let p = parseFloat((scrollTop / 100).toFixed(2))
        this.options = {
          barBackgroundColor: 'rgba(0, 0, 0, ' + p + ')',
          color: '#fff'
        }
      }
    },
    bindBuyVip(type) {
      if (!this.readProtocol) {
        this.$toast('请先阅读并同意会员服务协议')
        this.wobble = true
        setTimeout(() => {
          this.wobble = false
        }, 500)
        return
      }
      this.bindShop()
      this.$buryPoint('CLICK_BUYVIP', {})
      this.addLog('大会员点击开通-' + type)
    },
    //去商城
    bindShop() {
      if (this.$http._isApp()) {
        let id = this.$route.query.id
        let buyUrl = ''
        this.vipRightImage.map((item) => {
          if (item.id == id) {
            buyUrl = item.buyUrl
          }
        })
        if (id == 3 && this.activity618) {
          buyUrl = 'http://t.weimob.com/AG_CIVr'
        }
        if (buyUrl) {
          this.$betterwe.onAppPageUrlRoute(
            '/wmOtherPage?fromType=11&url=' + buyUrl + '&title=商城'
          )
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './components/activity618.scss';
.detail {
  overflow: hidden;
  width: 375px;
  min-height: 100vh;
  background-color: #131117;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/677e362e1d92fa3ad607b8c24abf47c0.png');
  background-size: contain;
  background-position: center top;
  background-repeat: no-repeat;

  ::v-deep .van-tabs__wrap {
    height: auto;
    overflow: visible;
  }

  ::v-deep .van-tab__text--ellipsis {
    overflow: visible;
  }

  ::v-deep .van-tabs__nav {
    background-color: transparent;
    padding: 0px 8px;
  }

  ::v-deep .van-tab {
    padding: 0;
    flex: none;
  }

  .nav-item {
    width: 72px;
    text-align: center;

    .icon {
      position: relative;
      width: 40px;
      height: 40px;
      margin: 0 auto 8px;

      .new {
        position: absolute;
        right: 0;
        top: 0;
        transform: translate(50%, -30%);
        text-align: center;
        width: 27px;
        height: 14px;
        background: linear-gradient(314deg, #ff7c2e 0%, #f75f3f 100%);
        border-radius: 8px 10px 10px 0px;
        font-size: 9px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 14px;
      }

      .image {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 229, 152, 0.7);
      line-height: 16px;
    }
  }

  .van-tab--active {
    .text {
      font-weight: 600;
      color: #ffe598;
    }
  }

  .content {
    margin-top: 19px;
    padding: 16px 0px;
    box-sizing: border-box;
    width: 100%;
    min-height: 70vh;
    background: #f7f7f7;
    border-radius: 20px 20px 0px 0px;
    @include paddingBottom(124px);

    .item-image {
      width: 343px;
      margin: 0 auto;
    }

    .image-1 {
      margin-bottom: 16px;
    }

    .image-2 {
      margin-bottom: 23px;
    }

    .more-course {
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 18px;
      margin-bottom: 20px;
    }
  }

  .btm-buy-btn-fixed {
    position: fixed;
    left: 0;
    bottom: 0px;
    background-color: #fff;
  }

  .btm-buy-btn {
    width: 100%;
    padding: 12px 16px 0px;
    @include paddingBottom(20px);
    box-sizing: border-box;

    .paomadeng {
      position: absolute;
      top: -38px;
      left: 0;

      .paomadeng-item {
        min-width: 147px;
        height: 22px;
        object-fit: contain;
        margin-right: 10px;
      }
    }

    .consult-btn {
      color: #000;

      .iconfont {
        font-size: 22px;
        margin-bottom: 4px;
      }

      .text {
        line-height: 14px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
      }
    }

    .protocol {
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999999;
      display: flex;
      align-items: center;
      line-height: 16px;
      margin-bottom: 19px;

      .check {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-right: 8px;
        box-sizing: border-box;
        border: 1px solid #999;
        display: flex;
        align-items: center;
        justify-content: center;

        .iconfont {
          font-size: 8px;
          color: #fff;
        }
      }

      .check-active {
        border: 1px solid rgba(255, 234, 173, 1);
        background: rgba(255, 234, 173, 1);
      }

      .text {
        color: rgba(220, 187, 99, 1);
        text-decoration: underline;
      }
    }

    .buy-content {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .buy-btn {
      width: 284px;
      height: 47px;
      border-radius: 24px;
      line-height: 47px;
      display: flex;
      align-items: center;
      box-shadow: 0px 5px 9px 0px rgba(237, 187, 154, 0.26);
      background: linear-gradient(
        110deg,
        #606044 0%,
        #1f1f30 60%,
        rgba(255, 227, 173, 1) 60%,
        rgba(238, 210, 126, 1) 100%
      );

      .b-buy-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: clip;
        padding-left: 24px;
        text-align: left;
        /*  display: flex;
                align-items: center; */

        .b-buy-unit {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffeaad;
          line-height: 16px;
          margin-right: 2px;
        }

        .b-buy-num {
          font-size: 32px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: #ffeaad;
        }

        .b-buy-desc {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffdab8;
          line-height: 16px;
        }

        .b-buy-time {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffeaad;
          line-height: 16px;
          margin-right: 4px;
        }
      }

      .b-buy-text {
        width: 110px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #202020;
        line-height: 16px;
      }
    }
  }
}
.check-wobble {
  animation: wobble 0.3s linear;
}

@keyframes wobble {
  0% {
    transform: translate(0px, 0px);
  }

  20% {
    transform: translate(-1px, 4px);
  }

  40% {
    transform: translate(3px, 0px);
  }

  60% {
    transform: translate(4px, 4px);
  }

  80% {
    transform: translate(-2px, -1px);
  }

  100% {
    transform: translate(2px, 0px);
  }
}
</style>
